import {
	IStackItemStyles,
	IStackTokens,
	Stack,
} from '@fluentui/react/lib/Stack';
import { observer } from 'mobx-react-lite';
import { IRootStateProps } from '../state/RootState';
import logo from '../img/FullLogo_Transparent_LightBG_studio.png';
import CombinedSearchCtrl from './controls/CombinedSearchCtrl';
import { SearchCtrlStyle } from './controls/SearchCtrl';
import CurrentUserAccount from './controls/CurrentUserAccount';
import { DefaultButton } from '@fluentui/react';
import { useMsal } from '@azure/msal-react';

const themedSmallStackTokens: IStackTokens = {
	childrenGap: 's1',
	padding: 's1',
};

const headerStyles: IStackItemStyles = {
	root: {
		textAlign: 'left',
		color: '#D9D9D9',
		fontSize: 20,
	},
};

const navBarStyles: IStackItemStyles = {
	root: {
		filter: 'drop-shadow(2px 1px 1px #cccccc)',
		height: 38,
		padding: 4,
		backgroundColor: '#EBEBEB',
	},
};

/**
 * Header bar
 */
export const Header = observer((props: IRootStateProps) => {
	if (props.RootState.hidePageNavigation) return <></>;

	let msalContext = useMsal();

	return (
		<Stack horizontal tokens={themedSmallStackTokens} styles={navBarStyles}>
			<Stack.Item styles={headerStyles}>
				<img
					src={logo}
					alt="logo"
					style={{ height: 30, paddingLeft: 3, cursor: 'pointer' }}
					onClick={() => {
						window.location.reload();
					}}
				/>
			</Stack.Item>

			<Stack.Item grow>
				<div style={{ width: '65%', margin: '0 auto' }}>
					
				{props.RootState.searchCtrlState && (
						<CombinedSearchCtrl
							state={props.RootState.searchCtrlState}
							placeholder={'Search across your organization...'}
							style={SearchCtrlStyle.Grey}
						/>
					)}
				</div>
			</Stack.Item>

			<Stack.Item>
					<div style={{ paddingRight: 10 }}>
						{/* Current user info */}
						{props.RootState.currentUserAccountState && (
							<CurrentUserAccount state={props.RootState.currentUserAccountState} />
						)}
					</div>

			</Stack.Item>
			
			<Stack.Item>
					<DefaultButton onClick={() => msalContext.instance.logoutRedirect()}>Sign out</DefaultButton>
			</Stack.Item>
		</Stack>
	);
});
